/* Global styles */
import "./sass/app.scss";

/* Global scripts */
import "./scripts/core";
  
const init = (() => {
	switch (wp_params.slug) {
		case "accueil":
			return require("./js/accueil");
			break;

		case "le-salon":
			return require("./js/le-salon");
			break;

		case "lacademie":
			return require("./js/lacademie");
			break;

		case "rendez-vous":
			return require("./js/rendez-vous");
			break;

		default: return { script: () => false }
	}
})().script();

